"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServPepp = void 0;
const base_1 = require("./base");
/**
 * Pepperjam Pixel
 */
class AnServPepp extends base_1.AnServBase {
    static sendCustEvent(pixelId, eventName, eventProps) {
        const eventPropsNew = Object.assign({}, eventProps);
        eventPropsNew.PROGRAM_ID = pixelId;
        const fUrl = (this.buildUrl("//t.pepperjamnetwork.com/track", [
            "INT",
            "PROGRAM_ID", "ORDER_ID", "ITEM_ID1", "ITEM_PRICE1",
            "QUANTITY1", "COUPON", "NEW_TO_FILE"
        ], eventPropsNew));
        this.renderElementIframe(fUrl);
        this.logEvent({
            url: fUrl
        });
        return true;
    }
}
exports.AnServPepp = AnServPepp;
AnServPepp.serviceName = "Pepperjam";
